import { Playground, Props } from 'docz';
import { Column } from 'simple-flexbox';
import CollapsibleContent from 'react-collapsible-content';
import ToggleButtonComponent from "../../../../../src/examples/common/ToggleButtonComponent";
import TextComponent from "../../../../../src/examples/common/TextComponent";
import CollapsibleContentProps from "../../../../../src/components/CollapsibleContentProps";
import * as React from 'react';
export default {
  Playground,
  Props,
  Column,
  CollapsibleContent,
  ToggleButtonComponent,
  TextComponent,
  CollapsibleContentProps,
  React
};